import { FormConfigBuilder } from 'components/form-builder/FormConfigBuilder';
import { format, parseISO } from 'date-fns';
import { Mission } from 'models/mission/Mission';
import { FormFieldCustomComponentTypes } from 'constants/FormFieldCustomComponentTypes';

// eslint-disable-next-line no-unused-vars
const formConfig = (methods = null, watch = null, mode) => {
    return new FormConfigBuilder(
        [
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'title',
                col: {
                    // Here you can specify how many Grid columns the field should take for the corresponding breakpoints
                    sm: 12,
                },
                list: true,
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'description',
                col: {
                    // Here you can specify how many Grid columns the field should take for the corresponding breakpoints
                    sm: 12,
                },
                list: {
                    minWidth: 300,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'createdAt',
                hideCondition: true,
                list: {
                    // type: "dateTime",
                    sorting: true,
                    filtering: false,
                    renderCell: params =>
                        params?.row.createdAt
                            ? format(
                                  parseISO(params?.row.createdAt),
                                  'HH:mm dd.MM.yyyy',
                              )
                            : '',
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'modifiedAt',
                hideCondition: true,
                list: {
                    // type: "dateTime",
                    sorting: true,
                    filtering: false,
                    renderCell: params =>
                        params?.row.modifiedAt
                            ? format(
                                  parseISO(params?.row.modifiedAt),
                                  'HH:mm dd.MM.yyyy',
                              )
                            : '',
                },
            },
        ],
        Mission,
    );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default [{ label: 'Mission Information', config: formConfig }];
